
<!--企业简介首页右侧-->
<template>

  <div >
    <div class="mybox">
      <div class="title">团队介绍</div>
      <div class="box">
        <NewList2></NewList2>
      </div>
    </div>
    <div class="mybox">
      <div class="title">企业资质</div>
      <div class="box">
        <el-carousel :interval="5000" class="cp_carousel">
          <el-carousel-item v-for="(item,index) in zizhiData" :key="index">
            <div class="zhizhilist">
              <div class="img" v-for="(list,i) in item" :key="i">
                <img :src="list.url">
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="mybox">
      <div class="title">获得荣誉</div>
      <div class="box">
        <el-carousel :interval="6000" class="cp_carousel">
          <el-carousel-item v-for="(item,index) in rongyuData" :key="index">
            <div class="rongyulist">
              <div class="img" v-for="(list,i) in item" :key="i" @click="RYclick(list)">
                <img :src="list.picture">
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="mybox">
      <div class="title">企业伙伴</div>
      <div class="box">
        <partner />
      </div>
    </div>

    <el-dialog v-dialogDrag :visible.sync="RYdialog" width="40%" title="荣誉介绍">
      <div class="rongyudialog">
        <img :src="RYinfo.picture">
        <div class="right">
          <div class="title">{{RYinfo.name}}</div>
          <div class="text">{{RYinfo.remark}}</div>
        </div>
      </div>
    </el-dialog>

  </div>

</template>

<script>
import api from '@/apis/CompanyProfile'
import NewList2 from './NewList2' //团队介绍
import partner from './partner' //合作伙伴
export default {
  components: {
  
    NewList2,
    partner,

  },
  data() {
    return {
      aboutus: {
        content: '暂无',
        industryProgress: 49,
        informatProgress: 79,
        smartProgress: 69,
      },



      zizhiData: [
        {
          id: 0,
          list: [
            { url: require('@/assets/images/pic2.png') },
            { url: require('@/assets/images/pic3.png') },
          ],
        },
        {
          id: 1,
          list: [
            { url: require('@/assets/images/pic3.png') },
            { url: require('@/assets/images/pic3.png') },
          ],
        },
      ],
      rongyuData: [
        {
          id: 0,
          list: [
            { id: 0, picture: require('@/assets/images/pic2.png') },
            { id: 1, picture: require('@/assets/images/pic3.png') },
            { id: 2, picture: require('@/assets/images/pic3.png') },
          ],
        },
        {
          id: 1,
          list: [
            { id: 3, picture: require('@/assets/images/pic3.png') },
            { id: 4, picture: require('@/assets/images/pic3.png') },
            { id: 5, picture: require('@/assets/images/pic2.png') },
          ],
        },
      ],
      lichengid: 0,
      licheng: [
        {
          id: 0,
          content: '请添加数据',
          eTime: '2017-07-01 00:00:00',
          backImg: require('@/assets/images/nodata.png'),
        },
        {
          id: 1,
          content: '请添加数据',
          eTime: '2018-08-01 00:00:00',
          backImg: require('@/assets/images/nodata.png'),
        },
        {
          id: 2,
          content: '请添加数据',
          eTime: '2019-09-01 00:00:00',
          backImg: require('@/assets/images/nodata.png'),
        },
        {
          id: 3,
          content: '请添加数据',
          eTime: '2020-10-01 00:00:00',
          backImg: require('@/assets/images/nodata.png'),
        },
      ],
      RYdialog: false,
      RYinfo: {
        name: 'name',
        picture: require('@/assets/images/pic.png'),
        remark: '内容',
      },
      //企业形像
      qyxx: {
        imgUrl: require('@/assets/images/pic.png'),
      },
      timer: null,
    }
  },
  methods: {
    lichengClick(index) {
      this.lichengid = index
    },
    RYclick(item) {
      // console.log(item)
      this.RYinfo = item
      this.RYdialog = true
    },

  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  mounted() {


    //企业资质
    api
      .certification({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          // console.log(res);
          let baseArray = res.data.list //[1, 2, 3, 4, 5, 6, 7, 8];
          let len = baseArray.length
          let n = 2 //假设每行显示2个
          let lineNum = len % n === 0 ? len / n : Math.floor(len / n + 1)
          let arr = []
          for (let i = 0; i < lineNum; i++) {
            // slice() 方法返回一个从开始到结束（不包括结束）选择的数组的一部分浅拷贝到一个新数组对象。且原始数组不会被修改。
            let temp = baseArray.slice(i * n, i * n + n)
            arr.push(temp)
          }
          this.zizhiData = arr
        } else {
          this.$message.error(res.message)
        }
      })

    //企业资质
    api
      .honor({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          // console.log(res);
          let baseArray = res.data.list //[1, 2, 3, 4, 5, 6, 7, 8];
          let len = baseArray.length
          let n = 3 //假设每行显示2个
          let lineNum = len % n === 0 ? len / n : Math.floor(len / n + 1)
          let arr = []
          for (let i = 0; i < lineNum; i++) {
            // slice() 方法返回一个从开始到结束（不包括结束）选择的数组的一部分浅拷贝到一个新数组对象。且原始数组不会被修改。
            let temp = baseArray.slice(i * n, i * n + n)
            arr.push(temp)
          }
          this.rongyuData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    //企业历程
    api
      .course({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          this.licheng = res.data.list
        } else {
          this.$message.error(res.message)
        }
      })
  },
}
</script>

<style lang="less" scoped>
.cp_home {
  height: 100%;
  width: 100%;
  overflow: hidden;
  padding: 0 0.5rem 0.5rem;
  & > .left {
    height: 100%;
    overflow: hidden;
    width: 25%;
    .mybox {
      flex: 1;
      height: 25%;
      overflow: hidden;
    }
  }
  & > .center {
    height: 100%;
    overflow: hidden;
    width: 50%;
    & > .top,
    & > .bottom {
      height: 50%;
      overflow: hidden;
    }
    & > .top {
      padding-bottom: 0.6em;
      .mybox {
        flex: 1;
        height: 100%;
        overflow: hidden;
      }
    }
    & > .bottom {
      .mybox {
        flex: 1;
        height: 50%;
        overflow: hidden;
      }
    }
  }
  & > .right {
    height: 100%;
    overflow: hidden;
    width: 25%;
    .mybox {
      flex: 1;
      height: 25%;
      overflow: hidden;
    }
  }
}
.aboutus {
    display: flex;
    flex-direction: column;
    padding: 0.71rem;
    font-size: 0.65rem;
    .text {
      flex: 1;
      overflow: hidden;
      line-height: 1.15rem;
    }

  }

  .cp_carousel {
    width: 100%;
    height: 100%;
    overflow: hidden;
    padding:0.5rem 0.5rem 1.2rem;
    .zhizhilist {
      width: 100%;
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: row;
      .img {
        width: 50%;
        margin: 0 0.3rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .rongyulist {
      width: 100%;
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: row;
      .img {
        width: 33.33%;
        margin: 0 0.3rem;
        img {
          width: 100%;
          height: 100%;
          cursor: pointer;
        }
      }
    }
  }

  .licheng {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    padding: 0.71rem 2.6rem 0.71rem 2.5rem;
    overflow: hidden;
    .preleft,
    .preright {
      position: absolute;
      top: 36%;
      width: 1.9rem;
      left: 10px;
      img {
        width: 100%;
      }
    }
    .preright {
      left: auto;
      right: 10px;
    }
    .lcbox {
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: row;

      &::before {
        content: ' ';
        position: absolute;
        width: 100%;
        height: 8px;
        background: #5586ff;
        border-radius: 20px;
        top: 92%;
      }
      .lilist:hover {
        position: relative;
        .image {
          color: #064f50;
        }
        img:hover {
          position: relative;
          box-shadow: 5px 5px 30px #1b1a1b;
          z-index: 4;
          transform: scale(1.1);
          // width: 110% !important;
          // height: 110% !important;
          // left: -5% !important;
          // top:-2%;
        }
      }

      .lilist {
        // width: 250%;
        min-width: 50px;
        width: 25%;
        height: 100%;
        // flex: 1;
        .image {
          position: relative;
          height: 80%;
          padding: 0 0.3rem;
          img {
            width: 100%;
            height: 100%;
            transition: all 0.5s;
          }
          span {
            z-index: 5;
            position: absolute;
            left: 0.5rem;
            bottom: 0.1rem;
          }
        }

        .progress {
          position: relative;
          z-index: 5;
          height: 20%;

          // flex: 1;
          text-align: center;
          z-index: 9;
          span {
            margin: 6px auto 0;
            cursor: pointer;
            width: 0.8rem;
            height: 0.8rem;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 1rem;
            background: #5586ff;
            border: #05f8fc solid 2px;
          }
        }

        .progress.active {
          color: #24ffb1;
          font-weight: bold;
          span {
            width: 1rem;
            height: 1rem;
            border: #24ffb1 solid 3px;
            margin-top: 3px;
          }
          span::after {
            content: ' ';
            position: relative;
            top: -0.8px;
            left: 0.5px;
            width: 0.4rem;
            height: 0.4rem;
            background: #24ffb1;
            border-radius: 50%;
          }
        }
      }
    }
  }

  .rongyudialog {
    display: flex;
    flex-direction: row;
    overflow: hidden;
    img {
      width: 19rem;
      height: 25rem;
      margin-right: 1rem;
    }
    .right {
      flex: 1;
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      .title {
        font-weight: bold;
        margin-bottom: 15px;
        font-size: 0.9rem;
      }
      .text {
        flex: 1;
        height: 100%;
        overflow-y: auto;
        line-height: 1rem;
      }
    }
  }
</style>
